export const COLUMN_CONFIG = {
  SAIA: "SAIA",
  DEFAULT: "DEFAULT",
}